export const RISK_TASK_ACTION_OPTIONS = [
  { value: "ignore", label: "忽略" },
  { value: "record", label: "记录" },
  { value: "ban", label: "封禁" },
];

export const RISK_TASK_ACTION_LABEL_MAP = RISK_TASK_ACTION_OPTIONS.reduce(
  (result, item) => {
    result[item.value] = item.label;
    return result;
  },
  {}
);

export const TASK_RUN_STATUS_LABEL_MAP = {
  success: "成功",
  failed: "失败",
  skipped: "跳过",
  running: "运行中",
  pending: "待处理",
  paused: "暂停",
  completed: "已完成",
};

export const TASK_RUN_STATUS_TYPE_MAP = {
  success: "success",
  failed: "danger",
  skipped: "warning",
  running: "primary",
  pending: "info",
  paused: "info",
  completed: "success",
};

export const RISK_LEVEL_LABEL_MAP = {
  safe: "安全",
  low: "低风险",
  medium: "中风险",
  high: "高风险",
};

export const RISK_LEVEL_TYPE_MAP = {
  safe: "success",
  low: "primary",
  medium: "warning",
  high: "danger",
};

export const RISK_SOURCE_LABEL_MAP = {
  realtime: "实时触发",
  scheduled: "定时任务",
};

export const RISK_SOURCE_RULE_TYPE_LABEL_MAP = {
  "0": "系统",
  "1": "登录规则",
  "2": "拉广规则",
  channel_risk_batch: "渠道风控批处理",
  risk_level_action: "风险分级处置",
  ecpm_check: "ECPM 检测",
};

export const RISK_POLICY_TYPE_LABEL_MAP = {
  risk_level_action: "风险分级处置",
  ecpm_check: "ECPM 检测",
};

export function isSystemTask(task = {}) {
  return Boolean(task && task.is_system_task);
}

export function isSystemScheduler(scheduler = {}) {
  return Boolean(scheduler && scheduler.is_system_scheduler);
}

export function getActionLabel(action) {
  return RISK_TASK_ACTION_LABEL_MAP[action] || action || "--";
}

export function getTaskRunStatusLabel(status) {
  return TASK_RUN_STATUS_LABEL_MAP[status] || status || "--";
}

export function getTaskRunStatusType(status) {
  return TASK_RUN_STATUS_TYPE_MAP[status] || "info";
}

export function getRiskLevelLabel(level) {
  return RISK_LEVEL_LABEL_MAP[level] || level || "--";
}

export function getRiskLevelType(level) {
  return RISK_LEVEL_TYPE_MAP[level] || "info";
}

export function getRiskSourceLabel(sourceType) {
  return RISK_SOURCE_LABEL_MAP[sourceType] || sourceType || "--";
}

export function getRiskSourceRuleTypeLabel(sourceRuleType) {
  return RISK_SOURCE_RULE_TYPE_LABEL_MAP[String(sourceRuleType || "")] || sourceRuleType || "--";
}

export function getPolicyTypeLabel(policyType) {
  return RISK_POLICY_TYPE_LABEL_MAP[String(policyType || "")] || policyType || "--";
}

export function getPolicyConfigSummary(policy = {}) {
  const type = String(policy.policy_type || "");
  const config = policy.policy_config || {};

  if (type === "risk_level_action") {
    const parts = [];
    if (config.min_risk_score !== undefined && config.min_risk_score !== null) {
      parts.push(`最低分 ${config.min_risk_score}`);
    }
    if (Number(config.cross_app_only) === 1) {
      parts.push("仅跨APP");
    }
    if (config.low_action) {
      parts.push(`低风险 ${getActionLabel(config.low_action)}`);
    }
    if (config.medium_action) {
      parts.push(`中风险 ${getActionLabel(config.medium_action)}`);
    }
    if (config.high_action) {
      parts.push(`高风险 ${getActionLabel(config.high_action)}`);
    }
    return parts.join(" / ") || "--";
  }

  if (type === "ecpm_check") {
    const parts = [];
    if (config.min_ecpm !== undefined && config.min_ecpm !== null) {
      parts.push(`最低ECPM ${config.min_ecpm}`);
    }
    if (config.min_num !== undefined && config.max_num !== undefined) {
      parts.push(`数量 ${config.min_num}-${config.max_num}`);
    }
    if (config.time !== undefined && config.time !== null) {
      parts.push(`封禁 ${config.time}s`);
    }
    return parts.join(" / ") || "--";
  }

  return "--";
}

export function normalizePolicyConfigValue(field = {}, value) {
  if (field.type === "switch") {
    return value === undefined ? 0 : Number(value) === 1 ? 1 : 0;
  }
  if (field.type === "number") {
    return value === undefined || value === null || value === "" ? null : Number(value);
  }
  return value;
}

export function mergePolicyDefaultConfig(defaultConfig = {}, config = {}) {
  return {
    ...defaultConfig,
    ...(config || {}),
  };
}

export function shouldShowPolicyField(field = {}, config = {}) {
  if (!field.showWhen) {
    return true;
  }
  const currentValue = config[field.showWhen.key];
  if (field.showWhen.equals !== undefined) {
    return currentValue === field.showWhen.equals;
  }
  return true;
}
